import styled from 'styled-components';

export const Main = styled.main`
    display: flex;
    flex-direction: column;
    padding: 20px;
`;

export const H1 = styled.h1`
    margin: 12px 0 20px 0;
    text-align: center;
`;

export const H2 = styled.h2`
    margin-bottom: 0;
`;
